/* manage different color logo on collection page having banner image */
  $('x-header').mouseenter(function () {
          if($(this).hasClass('collection_banner') && !$(this).hasClass('is-solid')){
                     console.log('white now');
                  if ($('a.header__logo').is('.transparent_logo'))
                  {
                      $('a.header__logo').removeClass('transparent_logo')
                  }
                  $('a.header__logo').html('<img src=https://cdn.shopify.com/s/files/1/0266/1774/1359/files/GDV_Logo_Horse_Above_2.png?v=1717710488" alt="" srcset="//www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_2.png?v=1717710488&amp;width=520 520w, //www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_2.png?v=1717710488&amp;width=780 780w" width="2000" height="1000" sizes="260px" class="header__logo-image">');
            }
          });
          $('x-header').mouseleave(function () {
            if($(this).hasClass('collection_banner') && !$(this).hasClass('is-solid')){
               console.log('grey logo');
                  if ($('a.header__logo').is('.transparent_logo')){}
                  else{
                      $('a.header__logo').addClass('transparent_logo')
                  }
                  $('a.header__logo').html('<img src="https://cdn.shopify.com/s/files/1/0266/1774/1359/files/GDV_Logo_Horse_Above_White_2.png?v=1717710491" alt="" srcset="//www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_White_2.png?v=1717710491&amp;width=520 520w, //www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_White_2.png?v=1717710491&amp;width=780 780w" width="2000" height="1000" sizes="260px" class="header__logo-image">');
            }
          });
/* //manage different color logo on collection page having banner image */

/*
  make the entirety of the slideshow clickable
*/
$('.slideshow__slide.is-selected').click(function(){
    var link = $(this).parent().find('a.link').attr('href');
    if(link != '' && link != 'undefined'){
    window.location.href = link;
    }
});


/*
 * Sticky header
*/
$(window).scroll(function(){
  var sticky = $('header'),
      scroll = $(window).scrollTop();
  if (scroll > 50) {
    console.log('add');
    sticky.addClass('sticky_header');
  }
  else{
    console.log('remove');
  sticky.removeClass('sticky_header');
  }
});


/* Portfolio detail page gallery */
  /* Images flow in one responsive grid (see portfolio-detail.liquid <style>);
     no fixed grouping, so they wrap cleanly at every screen width. */

/* Build a fast-loading (capped) URL for the enlarged popup image */
function portfolioFullSrc(el){
  var src = $(el).find('img.pr_img').attr('src') || '';
  if (!src) return '';
  if (src.indexOf('//') === 0) { src = 'https:' + src; }
  return /[?&]width=\d+/.test(src)
    ? src.replace(/([?&]width=)\d+/, '$11600')
    : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
}
/* Preload the popup image on hover so it opens instantly on click */
$('.port_image').on('mouseenter', function(){
  var s = portfolioFullSrc(this);
  if (s) { var im = new Image(); im.src = s; }
});

/* onclick href open large image */
$('.port_image').click(function(e){
    e.preventDefault();

  $('.port_full_img').empty();
  $('.port_full_img').remove();
  var getImage = portfolioFullSrc(this);

      var newDiv = '<div class="port_full_img"><span class="close" title="Close"><svg role="img" width="35" height="35" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="needsclick  kl-private-reset-css-Xuajs1"><title id="title-Close-dialog">Close dialog</title><circle cx="10" cy="10" r="9.5" fill="rgba(255,255,255,0)" stroke="rgba(255,255,255,0)" style="cursor: pointer;"></circle><path d="M6 6L14 14M6 14L14 6L6 14Z" stroke="rgba(43,44,46,1)" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" style="cursor: pointer;"></path></svg></span><img src="'+getImage+'"></div>';
      // Insert the enlarged image ABOVE the clicked image's current visual row
      // (works for rows of 2 or 3 — detects the row by matching vertical offset)
      var clicked = this;
      var rowItems = $(clicked).closest('.collection-list').children('a.port_image').toArray();
      var rowTop = clicked.offsetTop;
      var rowFirst = clicked;
      for (var ri = rowItems.indexOf(clicked) - 1; ri >= 0; ri--) {
        if (Math.abs(rowItems[ri].offsetTop - rowTop) < 2) { rowFirst = rowItems[ri]; }
        else { break; }
      }
      var $pop = $(newDiv);
      $(rowFirst).before($pop);
      // trigger the open transition on the next frame
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ $pop.addClass('is-open'); }); });

    setTimeout(
  function()
  {
    scrollToImage();//do something special
  }, 80);
});
/* //onclick href open large image */

function scrollToImage(){
      $('html, body').animate({
        scrollTop: $('div.port_full_img').offset().top - 120
      }, 'slow'); // The 'slow' argument controls the animation speed
}

/* onclick close large image */
$(document).on('click', '.close', function() {
  var $p = $(this).closest('.port_full_img');
  $p.removeClass('is-open');
  setTimeout(function(){ $p.remove(); }, 320);
});
/* //onclick close large image */
/* //Portfolio detail page gallery */